import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

import { ConfigSiteService } from '../../services/config-site.service';
import { SocialMediaService } from '../../services/social-media.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './footer.scss',
})
export class FooterComponent {
  private readonly configSiteService = inject(ConfigSiteService);
  private readonly socialMediaService = inject(SocialMediaService);

  readonly currentYear = new Date().getFullYear();
  readonly config = toSignal(this.configSiteService.getConfig());
  readonly socialMedia = toSignal(this.socialMediaService.getSocialMedia());
}
